<app-stepper-form
  header="Add a Trust"
  submitButtonText="Create Trust"
  [showSteps]="false"
  [showSaveAndCompleteLaterBtn]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [form]="stepperForm"
  [isLoading]="isLoading"
  (stepIndexChange)="setCurrentStep($event)"
  (confirm)="submit()"
  (close)="close()"
>
  <div class="step-content" [formGroup]="stepperForm">
    <section
      class="step-section"
      [formGroupName]="StepsEnum.TrustInformation"
      [hidden]="currentStep !== StepsEnum.TrustInformation"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-integrations-entity-search-control
          label="Trust Name"
          formControlName="name"
          [entityType]="EntityType.Trust"
          (trustSelected)="onTrustSelected($event)"
        >
          <button
            type="button"
            class="btn btn-secondary btn-icon"
            ngbTooltip="Import Trust Details"
            tooltipClass="tooltip-info"
            [disabled]="isLoading"
            (click)="openUploadTrustFileModal()"
          >
            <i class="icon ic-upload-file-20"></i>
          </button>
        </app-integrations-entity-search-control>
      </div>

      <div class="form-group">
        <app-select-groups
          label="Trust Type"
          formControlName="trustSubType"
          [optionGroups]="trustTypesOptionGroups"
        />
      </div>

      <div class="form-group controls-grid">
        <div>
          <app-abn-masked-input
            formControlName="abn"
          />
        </div>

        <div>
          <app-date-picker
            label="Commencement Date"
            formControlName="dateOfEstablishment"
            [minDate]="minDate"
            [maxDate]="maxDate"
          />
        </div>

        <div>
          <app-flags-autocomplete
            label="Jurisdiction"
            formControlName="jurisdiction"
            [options]="jurisdictionOptions"
          />
        </div>
      </div>

      <!-- ADDITIONAL DETAILS START -->

      <div ngbAccordion class="pt-1">
        <div ngbAccordionItem>
          <div ngbAccordionHeader>
            <div ngbAccordionToggle class="d-flex justify-content-between align-items-center">
              <span class="px-3 accordion-header-text">Additional Details</span>

              <button
                type="button"
                class="accordion-toggle-button btn"
              >
                <i class="icon ic-chevron-down-20"></i>
              </button>
            </div>
          </div>

          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="pb-0">
              <div class="form-group">
                <app-address-form-group
                  label="Registered Address"
                  [noValidators]="true"
                  [careOfAllowed]="true"
                  [formGroup]="trustInformationForm.controls.address"
                />
              </div>

              <div class="form-group">
                <app-multiple-input-datepicker
                  label="Dates of Variation"
                  formControlName="variationDates"
                  [minDateStruct]="defaultMinDateOrCommencementDate"
                  [maxDateStruct]="defaultMaxDateOrVestingDate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ADDITIONAL DETAILS END -->

      @if (trustFromDocument) {
        <div class="mt-4">
          <app-disclaimer
            color="orange"
            icon="ic-info-circle-20"
          >
            {{ analyseTrustPdfMessages.generatedTrustWarning }}
          </app-disclaimer>
        </div>
      }

    </section>
  </div>
</app-stepper-form>
